export const GET_FLASHCARDS_REQUEST = 'flashcardReducer/GET_FLASHCARDS_REQUEST';
export const GET_FLASHCARDS_SUCCESS = 'flashcardReducer/GET_FLASHCARDS_SUCCESS';
export const GET_FLASHCARDS_FAILED = 'flashcardReducer/GET_FLASHCARDS_FAILED';
